((win) => {
  win.login = async function(previousUrl) {
    // 記錄當前網址，使得登入完後直接回到該頁
    let redirectUrl = previousUrl
    if (!redirectUrl){
      redirectUrl = window.location.href
    }
    // 添加一個 query
    redirectUrl = new URL(redirectUrl)
    redirectUrl.searchParams.set("login_from_center", "true")
    sessionStorage.setItem("previousURL", redirectUrl)
    authSvc.signInRedirect();
  }

  win.logout = function logout(){
    // 清除 session
    sessionStorage.removeItem("previousURL");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userToken");
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userFav");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("useAccessToken");
    sessionStorage.removeItem("idp")
    sessionStorage.removeItem("lock")

    // 直接跳轉到登出頁面
    authSvc.signOutRedirect()
  }

  win.checkLogin = async function checkLogin(){
    let user = await authSvc.getUser();
    if (user === null){
      await login();
    } else {
      let exp = user.profile ? user.profile.exp : null
      await reLoginIfTokenExpired(exp)
    }
  }

  win.getUserInfo = async function getUserInfo(){
    let accessToken = sessionStorage.getItem("accessToken")
    let userToken = sessionStorage.getItem("userToken")

    if (!accessToken  || !userToken) {
      // 若沒有 對應的 token，則從 getUser 取得
      let user = await authSvc.getUser()
      let profile = null
      if (user) {
        profile = user.profile
        // 若有登入成功，應會拿到資料
        await updateUserInfo(user)
        const exp = profile ? profile.exp : null
        await reLoginIfTokenExpired(exp)
      }

    } else {
      const user = {
        access_token: accessToken,
        id_token: userToken
      }
      await updateUserInfo(user)
    }
  }

  win.refreshToken = async function refreshToken(refreshToken){
    if (!refreshToken) return
    const url= 'https://hanlin-token.hle.com.tw'
    let newTokenInfo = null
    try {
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: refreshToken
        })
      })
      newTokenInfo = await resp.json()

      updateUserInfoByAccessToken(newTokenInfo)
    } catch (e) {
      console.log(e)
      // 登出
      this.logout()
    }
  }
  win.checkLock = async function checkLock(accessToken){
    const url= 'https://hanlin-token.hle.com.tw'
    const resp = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
      mode: 'cors'
    })
    const result = await resp
    if (result.status === 200) {
       // lock = false
      sessionStorage.setItem("lock", false);
    } else  {
      // lock = true
      sessionStorage.setItem("lock", true);
    }
  }

  win.getUserInfoByEndpoint = async function getUserInfoByEndpoint(accessToken){
    try{
      let resp = await authSvc.getUserByEndpoint(accessToken);
      if (resp !== null && resp.status === 200){
        sessionStorage.setItem("useAccessToken", "true")
        return resp
      }
      return "invalid token"
    }catch (e){
      console.log(e)
      return "invalid token"
    }

  }

  win.updateUserInfo = async function updateUserInfo(user){
    // 若有登入成功，應會拿到資料
    if (user){
      const url = new URL(window.location.href)
      this.edu = url.searchParams.get("edu")
      const payload = base64ToJson(getTokenPayload(user.access_token));


      sessionStorage.setItem("userToken", user.id_token)
      sessionStorage.setItem("accessToken", user.access_token)


      sessionStorage.setItem("userName", payload.preferred_username)
      sessionStorage.setItem("userEmail", payload.email)
      sessionStorage.setItem("userRole",payload.role)
      sessionStorage.setItem("idp", payload.idp)
      sessionStorage.setItem("lock", payload.lock)


      if (this.edu) {
        let fav = await favSvc.retrieveFavoriteBookByEmailEdu({
          email: payload.email,
          edu: this.edu
        });
        fav = fav.data;
        sessionStorage.setItem("userFav", JSON.stringify(fav))
      }
    }
  }

  updateUserInfoByAccessToken = (userToken) => {
    if (!userToken) return

    const accessToken = userToken.access_token
    const idToken = userToken.id_token
    sessionStorage.setItem("accessToken", accessToken)
    sessionStorage.setItem("userToken", idToken)


    const payload = base64ToJson(getTokenPayload(accessToken));
    if (payload && payload.sub) {
      sessionStorage.setItem("userId", payload.sub);
      sessionStorage.setItem("name", payload.preferred_username);
      sessionStorage.setItem("email", payload.email);
      sessionStorage.setItem("role", payload.role);
      sessionStorage.setItem("idp", payload.idp);
      sessionStorage.setItem("lock", payload.lock);
    }
  }

  const reLoginIfTokenExpired =  async function checkTokenExpire(exp){
    if (!exp) return true
    const now = Math.floor(Date.now() / 1000)
    if (exp < now) {
      await login()
    }
  }


  const base64ToJson = (str) =>{
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')));
  }

  const getTokenPayload = (token) => {
    return token.split('.')[1];
  }

})(window)
